import { store } from '~/utility/BinSentry-ui-utility';
import { LitEntity, html } from '../../utility/lit-entity';
import { BnModalMixin } from '../../common/bn-modal-mixin';
import { StoreMixin } from '../../utility/store-mixin';
import i18n from '../../../../i18n';
import '../../common/bn-action';
import '../../common/bn-flash';

class ExportBinsModal extends StoreMixin(BnModalMixin(LitEntity)) {
  constructor() {
    super();
    this.id = 'export-bins-modal';
    this._stateChanged(store.getState());
  }

  static get properties() {
    return {
      actionHref: { type: String, attribute: false },
      binsHref: { type: String, attribute: false },
    };
  }

  renderContents() {
    return html`
      <style>
        #export-bins-modal {
          --modal-min-width: 50%;
        }
        :host {
          text-align: center;
        }
        organization-ancestors-bread-crumbs {
          display: inline;
          min-width: calc(100% - 300px);
        }
        .adding-into {
          margin-top: 0.75em;
          display: flex;
          margin-bottom: 1em;
          opacity: .7;
        }
        h3 {
          margin: 0;
        }
        p {
          text-align: center;
          margin: 1em 0 0 0;
        }
        p.dynamic {
          margin: 0 0 2em 0;
          color: var(--black-base);
        }
      </style>

      <h3 slot="title">${i18n.t('exporter.exportLevelData')}</h3>
      <bn-flash id="status"></bn-flash>

      <p>${i18n.t('exporter.requestCsvExportFrom')}</p>
      <p class="dynamic">
        <organization-ancestors-bread-crumbs .href="${this.href}" linkPath="" ancestorMinIndex="0">
        </organization-ancestors-bread-crumbs>
      </p>
      <p>${i18n.t('exporter.emailDeliveryInfo')}</p>
      <p class="dynamic">
        <user-email .href="${this.userHref}"></user-email>
      </p>
      <p>${i18n.t('exporter.requestTimeframe')}</p>
      <p>
        <bn-action
          .href="${this.binsHref}"
          submittext="${i18n.t('exporter.request')}"
          actionname="request-csv-export"
          successtext="${i18n.t('exportBinsModal.requestSuccessMessage')}"
          errortext="${i18n.t('exportBinsModal.requestErrorMessage')}"
        >
          <span slot="header"></span>
        </bn-action>
      </p>
    `;
  }

  _entityChanged(entity) {
    super._entityChanged(entity);
    if (!this.entity) {
      return;
    }

    this.binsHref = this.getHref('https://api.binsentry.com/rel/v2/bins');
  }

  _stateChanged({ currentUserHref }) {
    this.userHref = currentUserHref;
  }
}

window.customElements.define('export-bins-modal', ExportBinsModal);
